import downloadManagerService from '@/services/downloadManagerService';

export default {
  install(Vue) {
    // Add the download manager service as a global property
    Vue.prototype.$downloadManager = downloadManagerService;

    // Add global mixin for easy access
    Vue.mixin({
      computed: {
        $downloads() {
          return this.$downloadManager.downloads;
        },
        $downloadManagerVisible() {
          return this.$downloadManager.isVisible;
        }
      }
    });
  }
};